import { render } from "./LoginMobileNumbers.vue?vue&type=template&id=60126271"
import script from "./LoginMobileNumbers.vue?vue&type=script&lang=js"
export * from "./LoginMobileNumbers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__